<template>
    <nav>
        <div class="container">
            <div class="nav">
                <a class="logo">
                    <div class="logo-img">
                        <router-link :to="logoLink">
                            <img src="@/assets/img/prime_logo.png" alt="BIB Institute" />
                        </router-link>
                    </div>
                    <div class="logo-text">
                        <router-link :to="logoLink">
                            <p>Prime International School</p>
                        </router-link>
                    </div>
                </a>
                <div class="top-nav align-center" :class="{ open: isMenuOpen }">
                    <div class="dropdown" @click="toggleDropdown">
                        <a class="dropdown-menu">
                            <i class="fa-solid fa-user"></i>
                            {{ this.$store.state.user.name | adminDisplayName }}
                            <span><i class="fa-solid fa-caret-down"></i></span>
                        </a>
                        <ul class="dropdown-item dropdown_menu--animated dropdown_animation" :class="{ show: isDropdownOpen }">
                            <li>
                                <router-link :to="{ name: 'school', params: { id: this.$store.state.user.campus_id } }">
                                    <a>Campus Info</a>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="profileLink">
                                    <a>Profile</a>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'myTimetable' }">
                                    <a>My Timetable</a>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'updatePassword' }">
                                    <a>Update Password</a>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'myPayslipList' }">
                                    <a>My Payslip Records</a>
                                </router-link>
                            </li>
                            <li class="border">
                                <a @click="logoutUser" class="btn-cursor"><i class="fa-solid fa-right-from-bracket"></i>
                                    Logout</a>
                            </li>
                        </ul>
                    </div>
                    <div class="hamburger" @click="toggleMenu" :class="{ open: isMenuOpen }" v-if="id != '0001'">
                        <div class="hamburger-line" v-for="index in 3" :key="index"></div>
                    </div>
                </div>
            </div>
            <div class="nav-menu" :class="{ open: isMenuOpen }">
                <ul class="nav-menu-list">
                    <li class="dropdown" :class="{ active: isDashboardActive }">
                        <router-link :to="{ name: 'teacherDashboard' }"><a class="dd-hover"><i class="fa-solid fa-house"></i>Dashboard</a></router-link>
                    </li>

                    <li class="dropdown" :class="{ active: isTeacherMenuActive }">
                        <a class="dropdown-menu" @click="toggleDropdown"><i class="fa-solid fa-people-roof"></i>Teachers</a>
                        <ul class="dropdown-item dropdown-item-columns dropdown_menu--animated dropdown_animation" :class="{ show: isDropdownOpen }">
                            <li>
                                <router-link :to="{ name: 'holidayList' }"><a>Holiday List</a></router-link>
                            </li>
                            <li v-if="enableMenu('homeRoomTeacher', 'subjectTeacher', 'assistantTeacher')">
                                <router-link :to="{ name: 'timetableList' }"><a>TimeTable List</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'courseList' }"><a>Course List</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'attendanceTeacherList' }"><a>Attendance List</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'teacherMonthlyAttendance' }"><a>Monthly Attendance History</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'teacherLeaveList' }"><a>Leave List</a></router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="dropdown" :class="{ active: isStudentMenuActive }" v-if="enableMenu('homeRoomTeacher', 'subjectTeacher', 'assistantTeacher')">
                        <a class="dropdown-menu" @click="toggleDropdown"><i class="fa-solid fa-people-line"></i>Students</a>
                        <ul class="dropdown-item dropdown-item-columns dropdown_menu--animated dropdown_animation" :class="{ show: isDropdownOpen }">
                            <li>
                                <router-link :to="{ name: 'studentList' }"><a>Student List</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'examList' }"><a>Exam List</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'gradingList' }"><a>Grading List</a></router-link>
                            </li>
                            <li v-if="enableMenu('homeRoomTeacher', 'assistantTeacher')">
                                <router-link :to="{ name: 'earlyYearList' }"><a>Early Year Grading List</a></router-link>
                            </li>
                            <li v-if="enableMenu('homeRoomTeacher', 'assistantTeacher')">
                                <router-link :to="{ name: 'attendanceStudentList' }"><a>Daliy Attendance List</a></router-link>
                            </li>
                            <li v-if="enableMenu('homeRoomTeacher', 'assistantTeacher')">
                                <router-link :to="{ name: 'monthlyAttendance' }"><a>Monthly Attendance List</a></router-link>
                            </li>
                            <li v-if="enableMenu('homeRoomTeacher', 'assistantTeacher')">
                                <router-link :to="{ name: 'leaveList' }"><a>Leave List</a></router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'reportCardGradingList' }"><a>Report Card Grading List</a></router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import store from "@/store";
import axios from "axios";
import { routeNames } from '@/assets/js/routeMenus.custom';
import CONFIG from "@/assets/js/config.custom.js";
export default {
    name: "HeaderPage",
    data() {
        return {
            role: store.state.user.role,
            id: store.state.user.teacher_no,
            campusCode: store.state.user.campus_master.campus_code,
            isMenuOpen: false,
            isDropdownOpen: false,
            CONFIG,
        };
    },

    computed: {
        logoLink() {
            return { name: 'teacherDashboard' };
        },
        profileLink() {
            const employeeId = this.$store.state.user.employee?.id ?? this.$store.state.user.employee_id;
            return { name: 'employeeProfile', params: { id: employeeId } };
        },
        roleLabels() {
            return this.$store.state.user.roleLabels || [];
        },
        isDashboardActive() {
            return routeNames.dashboardRoutes.includes(this.$route.name);
        },
        isTeacherMenuActive() {
            return (
                routeNames.teacherRoutes.includes(this.$route.name) ||
                (routeNames.operationRoutes && routeNames.operationRoutes.includes(this.$route.name))
            );
        },
        isStudentMenuActive() {
            return routeNames.studnetRoutes.includes(this.$route.name);
        },
    },

    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        logoutUser() {
            axios
                .delete("/logout")
                .then((res) => {
                    if (res.data.success == true) {
                        this.$store.commit("logout");
                        this.$router.push({ name: "login" });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                });
        },
        enableMenu(...roles) {
            return this.roleLabels.some(role => roles.includes(role));
        }
    }
};
</script>

<style>
@import "@/assets/css/custom/custom-header.css";
</style>
